<template>
	<div class="column-input">
		<div class="prefix-icons">
			<span>
				<NumberSvg />
			</span>
		</div>
		<!-- pass $attrs to child means pass all attributes of component that arent explicit declare as props -->
		<RichTextBox
			:value="value"
			v-bind="$attrs"
			v-on="$listeners"
			:isFocused="isFocused"
			:showDataMenu="showDataMenu"
			:ref="RICH_EDITOR_REFERENCE_NAME"
		/>
		<div v-if="isNoValue && showOpenMenuButton" class="prefix">Type '/' to insert data</div>
		<div v-if="showOpenMenuButton" class="suffix-icons">
			<OpenMenuButton v-on="$listeners" />
		</div>
	</div>
</template>

<script>
import OpenMenuButton from '@/components/BlockEditor/BlockEditorParams/inputsComponents/assets/OpenMenuButton';
import InputComponentMixinBase from './mixins/InputComponentMixinBase';
import NumberSvg from './assets/NumberSvg';
export default {
	name: 'NumberPropertyInput',
	mixins: [InputComponentMixinBase],
	components: { NumberSvg, OpenMenuButton },
	props: {
		isFocused: { type: Boolean },
		showDataMenu: { type: Boolean },
		value: { type: [String, Number, Boolean, null, Array, Object] },
	},
	computed: {
		showOpenMenuButton() {
			return this.isFocused && !this.showDataMenu;
		},
		isNoValue() {
			return !this.value || this.value === '';
		},
	},
};
</script>
<style lang="scss" scoped>
.column-input {
	position: relative;

	.prefix-icons {
		position: absolute;
		top: 4px;
		left: 9px;
		z-index: 1;
	}

	.prefix {
		top: 8px;
		left: 22px;
		font-size: 14px;
		position: absolute;
		color: var(--insert-data-placeholder);
		z-index: 1;
	}

	.suffix-icons {
		right: 10px;
		position: absolute;
		top: 5px;
		z-index: 1;
	}

	::v-deep {
		.ProseMirror {
			padding-left: 25px;

			.is-empty {
				margin-left: -5px;
			}
		}
	}
}
</style>
